import { useEffect, useState } from "react";
import InputCustom from "./InputCustom";
import { handleEditUser } from "./UserService";
import Loading from "../../SubDashboard/Loading/Loading";
import { normalizePhone } from "./PhoneUtils";
import AvatarUpload from "../../Users/SubUsers/AvatarUpload";
import axios from "axios";
import { Globals } from "../../../../Global";
import { downloadImage, getImageFileInfo, uploadOrganizationAvatar } from "../../../../Api/Network";
import ImagePreviewModal from "../Modal/ImagePreviewModal";

function EditUser({ user, close, openError, openSuccess }) {

    const [form, setForm] = useState({
        name: user.name || "",
        phone: user.phoneNumber || "",
        bio: user.profileText || "",
        urlWebHook: user.webHookCallbackUrl || "",
        tokenWebHook: user.webHookToken || "",
        ip: user.ip || "",
        avatar: null
    });

    const [preview, setPreview] = useState(user.avatarUrl || null);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [validationActive, setValidationActive] = useState(false);
    const [avatarLoading, setAvatarLoading] = useState(false);
    const [showImagePreview, setShowImagePreview] = useState(false);

    // ✅ انتخاب تصویر
    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setForm(prev => ({ ...prev, avatar: file }));
        setPreview(URL.createObjectURL(file));
    };

    const validateForm = () => {
        const newErrors = {};
        let finalPhone;

        if (!form.phone.trim()) {
            newErrors.phone = "شماره موبایل نمی‌تواند خالی باشد.";
        } else {
            try {
                finalPhone = normalizePhone(form.phone);
            } catch (err) {
                newErrors.phone = err.message;
            }
        }

        if (!form.urlWebHook.trim()) {
            newErrors.urlWebHook = "آدرس وب‌هوک نمی‌تواند خالی باشد.";
        }

        if (!form.tokenWebHook.trim()) {
            newErrors.tokenWebHook = "توکن وب‌هوک نمی‌تواند خالی باشد.";
        }

        setErrors(newErrors);

        return {
            isValid: Object.keys(newErrors).length === 0,
            finalPhone
        };
    };

    const handleChange = (field) => (value) => {
        setForm(prev => ({ ...prev, [field]: value }));

        if (!validationActive) return;

        if (field === "phone") {
            try {
                normalizePhone(value);
                setErrors(prev => ({ ...prev, phone: "" }));
            } catch (err) {
                setErrors(prev => ({ ...prev, phone: err.message }));
            }
        }

        if (field === "urlWebHook") {
            setErrors(prev => ({
                ...prev,
                urlWebHook: value.trim() ? "" : "آدرس وب‌هوک نمی‌تواند خالی باشد."
            }));
        }

        if (field === "tokenWebHook") {
            setErrors(prev => ({
                ...prev,
                tokenWebHook: value.trim() ? "" : "توکن وب‌هوک نمی‌تواند خالی باشد."
            }));
        }
    };

    const handleClose = () => {
        setErrors({});
        setValidationActive(false);
        close(false);
    };

    const onSubmit = async () => {
        setValidationActive(true);

        const { isValid, finalPhone } = validateForm();
        if (!isValid) return;

        setLoading(true);

        try {

            let avatarBinary = null;

            if (form.avatar) {
                await uploadOrganizationAvatar(
                    Globals.token,
                    form.avatar,
                    user.id,
                    form.urlWebHook,
                );
            }

            const data = await handleEditUser({
                id: user.id,
                name: form.name,
                phone: finalPhone,
                bio: form.bio,
                urlWebHook: form.urlWebHook,
                tokenWebHook: form.tokenWebHook,
                ip: form.ip,
                avatar: avatarBinary // اگر backend نیاز داشته باشه
            });

            if (data.status === 200) {
                openSuccess(`کاربر ${user.id} با موفقیت ویرایش شد.`);
                handleClose();
            } else {
                openError(data.message || "ویرایش با خطا مواجه شد.");
            }

        } catch (err) {
            console.error(err);
            openError(err.message || "عملیات با خطا مواجه شد.");
        } finally {
            setLoading(false);
        }
    };
    const fields = [
        { title: "نام", field: "name" },
        { title: "شماره موبایل", field: "phone" },
        { title: "IP", field: "ip" },
        { title: "متن بیوگرافی", field: "bio" },
        { title: "webHookCallbackUrl", field: "urlWebHook" },
        { title: "webHookToken", field: "tokenWebHook" },
        { title: "TokenHeader", field: "webHookTokenHeader" },
    ];

    useEffect(() => {
        let imageObjectUrl = null;
        const fetchAvatar = async () => {
            try {
                if (user?.avatars?.length > 0) {
                    setAvatarLoading(true);
                    const avatarId = user.avatars[0];
                    const token = localStorage.getItem("token");
                    const fileInfo = await getImageFileInfo(
                        token,
                        avatarId
                    );
                    const imageBlob = await downloadImage(
                        token,
                        avatarId,
                        fileInfo.fileSize
                    );
                    imageObjectUrl = URL.createObjectURL(imageBlob);
                    setPreview(imageObjectUrl);
                }

            } catch (error) {
                console.log(error);
            } finally {
                setAvatarLoading(false);
            }
        };

        fetchAvatar();

        return () => {
            if (imageObjectUrl) {
                URL.revokeObjectURL(imageObjectUrl);
            }
        };

    }, [user]);

    return (
        <>
            <div
                className="modal-overlay fixed top-0 left-0 w-screen h-screen bg-black opacity-40"
                onClick={handleClose}
            ></div>

            <div className="fixed top-14 left-1/2 transform -translate-x-1/2 bg-primary-100 rounded-lg px-20 py-14">
                <div className="flex items-center justify-between mb-6">
                    <img
                        src="/image/icon/close.png"
                        className="w-5 cursor-pointer"
                        onClick={handleClose}
                    />
                    <p className="text-right text-lg font-bold">ویرایش سازمان</p>
                </div>

                <div className="flex justify-end mb-6">
                    {
                        avatarLoading ? (
                            <div className="w-24 h-24 bg-slate-100 rounded-full p-8">
                                <div className="w-full h-full border-4 border-slate-300 border-t-primary-500 rounded-full animate-spin opacity-50"></div>
                            </div>

                        ) : (
                            <AvatarUpload
                                preview={preview}
                                onImageChange={handleImageChange}
                                onPreviewClick={() => setShowImagePreview(true)}
                            />
                        )
                    }
                </div>

                <div className="my-4">
                    <span className="text-right p-1 w-72 rounded inline-block">
                        {user.id}
                    </span>
                    <label className="w-40 text-sm text-right text-slate-500 inline-block">
                        : شناسه
                    </label>
                </div>

                {fields.map(f => (
                    <div className="mb-4" key={f.field}>
                        <InputCustom
                            title={f.title}
                            value={form[f.field]}
                            onChange={handleChange(f.field)}
                            error={errors[f.field]}
                        />
                    </div>
                ))}

                <div className="flex flex-row-reverse justify-between gap-4 mt-10">
                    <button
                        onClick={onSubmit}
                        className="bg-primary-500 flex-1 rounded-lg text-white p-2"
                    >
                        ویرایش
                    </button>
                    <button
                        onClick={handleClose}
                        className="border border-primary-500 flex-1 rounded-lg text-primary-500 p-2"
                    >
                        لغو
                    </button>
                </div>
            </div>
            <ImagePreviewModal
                image={preview}
                open={showImagePreview}
                onClose={() => setShowImagePreview(false)}
            />
            {loading && <Loading />}
        </>
    );
}

export default EditUser;